import { useEffect, useState } from "react";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import ComplaintRichTextEditor from "./ComplaintRichTextEditor";
import { isRichTextEmpty } from "../mapCtripEvents";
import { CS_EVENT_TYPE_OPTIONS } from "../constants";
import "./complaintManagement.css";

const CustomerServiceReply = ({ complaint, onSubmit, loading }) => {
  const defaultEventTypeId = complaint?.eventDetail?.eventTypeId
    ? String(complaint.eventDetail.eventTypeId)
    : "";

  const [eventTypeId, setEventTypeId] = useState(defaultEventTypeId);
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [editorKey, setEditorKey] = useState(0);

  useEffect(() => {
    setEventTypeId(defaultEventTypeId);
  }, [defaultEventTypeId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isRichTextEmpty(message) || !eventTypeId) return;
    onSubmit({
      message,
      attachments: files,
      eventTypeId: Number(eventTypeId),
    });
    setMessage("");
    setFiles([]);
    setEditorKey((key) => key + 1);
  };

  const defaultOptionMissing =
    defaultEventTypeId &&
    !CS_EVENT_TYPE_OPTIONS.some(
      (item) => String(item.id) === defaultEventTypeId
    );

  return (
    <form className="cmp-reply-form" onSubmit={handleSubmit}>
      <h4 className="cmp-section-title">Reply</h4>

      <div className="cmp-filter-field">
        <label>Event Type</label>
        <select
          value={eventTypeId}
          onChange={(e) => setEventTypeId(e.target.value)}
          required
        >
          <option value="">Select event type</option>
          {defaultOptionMissing && (
            <option value={defaultEventTypeId}>
              {complaint.eventDetail?.eventTypeName ||
                `Event Type ${defaultEventTypeId}`}
            </option>
          )}
          {CS_EVENT_TYPE_OPTIONS.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name_en}
            </option>
          ))}
        </select>
      </div>

      <ComplaintRichTextEditor
        value={message}
        onChange={setMessage}
        placeholder="Type your reply to Ctrip..."
        editorKey={editorKey}
        minHeight={160}
      />
      <div className="cmp-file-upload">
        <label className="cmp-file-label">Attach Files</label>
        <input
          type="file"
          multiple
          onChange={(e) => setFiles(Array.from(e.target.files || []))}
        />
        {files.length > 0 && (
          <div className="cmp-file-list">
            {files.map((f, i) => (
              <span key={i} className="cmp-attachment-chip">
                📎 {f.name}
              </span>
            ))}
          </div>
        )}
      </div>
      <MOButtonV2
        text="Submit Reply"
        type="submit"
        textColor="#ffffff"
        backgroundColor="#29AEE6"
        height={36}
        fontSize={13}
        padding="8px 28px"
        radius={4}
        loading={loading}
        disabled={isRichTextEmpty(message) || !eventTypeId || loading}
      />
    </form>
  );
};

export default CustomerServiceReply;
